import React from 'react'
import ServicesSection from '../Home/sub/ServicesSection'
import SectionTitle from '../../components/SectionTitle/SectionTitle'
import NetworkSolutionsPage from './sub/NetworkSolutionsPage'

export default function Services() {
  return (
    <>
    <SectionTitle title="Our Services" />

        <ServicesSection />
        <NetworkSolutionsPage />
    
    </>
  )
}
